import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GlobalNav from "../components/GlobalNav";
import Footer from "../components/Footer";
import { deltaToHtml } from "../utils/quillDelta";
import "./NotePost.css";

// Real /notes/:id route (a genuinely new backend endpoint -- none of the
// four existing type-filtered routes in routes/public/notes.js let you
// fetch an arbitrary note by id). No comment form/list here -- unlike
// blogs, the notes table has no comments column at all, so faking one
// would be building a feature the schema doesn't actually support.
function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric',
  });
}

export default function NotePost() {
  const { id } = useParams();
  const [note, setNote] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    fetch(`/api/notes/${id}`)
      .then((res) => {
        if (!res.ok) throw new Error('Not found');
        return res.json();
      })
      .then((data) => setNote(data))
      .catch(() => setNotFound(true))
      .finally(() => setLoading(false));
  }, [id]);

  return (
    <div className="notepost-page">
      <GlobalNav activeHref="/" ctaLabel="Join the collective" />

      <div className="notepost-body">
        {loading && <p className="notepost-loading">Loading…</p>}

        {!loading && notFound && (
          <p className="notepost-empty">This note doesn't exist, or may have been removed.</p>
        )}

        {!loading && note && (
          <div className="notepost-card">
            {note.date && <div className="notepost-date">{formatDate(note.date)}</div>}
            <h1 className="notepost-title">{note.title}</h1>
            {note.short && <p className="notepost-short">{note.short}</p>}

            {note.photourl && (
              <div className="notepost-image">
                <img src={note.photourl} alt={note.title} />
              </div>
            )}

            {note.description && (
              <div className="notepost-description" dangerouslySetInnerHTML={{ __html: deltaToHtml(note.description) }} />
            )}

            {(note.embedlink || note.iframelink) && (
              <div className="notepost-embed">
                <iframe
                  src={note.embedlink || note.iframelink}
                  title={note.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
            )}

            {note.videourl && !note.embedlink && !note.iframelink && (
              <div className="notepost-embed">
                <video controls>
                  <source src={note.videourl} type="video/mp4" />
                </video>
              </div>
            )}

            {note.audio && (
              <audio className="notepost-audio" controls src={note.audio} />
            )}

            {note.articlelink && (
              <a
                href={note.articlelink}
                target="_blank"
                rel="noopener noreferrer"
                className="mihu-btn-primary-lg notepost-article-link"
              >
                Read the full article →
              </a>
            )}
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
}